<template>
  <div>
    <div class="contentArea container">
      <div class="leftContent">
        <UserInfoInput :user-info="userInfo" />
        <TermsInfoInput :terms-info="termsInfo" />
      </div>
    </div>
    <div class="buttonGroup">
      <button class="moveButton" @click="prevStage"><span>이전</span></button>
      <button class="moveButton" @click="ConfirmReserveNew"><span>다음</span></button>
    </div>
  </div>
</template>

<script>
import UserInfoInput from '@/pages/PleisureReservePage/Components/UserInfoInput';
import TermsInfoInput from '@/pages/PleisureReservePage/Components/TermsInfoInput';
import moment from 'moment';
import reserveService from '@/pages/PleisureReservePage/API/reserve.service';
import {DateUtil} from '@/util/DateUtil';
import GeneralUtil from '@/util/GeneralUtil';

import hotelType from '../API/hotelType';
import {hotelGTagSendTo} from '@/pages/Reservation/hotelGTag';
import {PMS_YYYYMMDD} from '@/pages/PleisureReservePage/Model/reserve.model';

export default {
  name: 'Stage2',
  props: {
    ReserveData: Object,
  },
  computed: {
    selectedMember() {
      return this.$store.getters['Auth/selectedMember'];
    },
  },
  mixins: [GeneralUtil],
  data() {
    return {
      receiptWorking: false,
      isMobile: true,
      isScroll: false,
      userInfo: {
        bookName: '',
        bookHpNo: '',
        email: '',
      },
      termsInfo: {
        agreeCancel: false,
        agreePersonalCollect: false,
        agreePersonalGive: false,
        agreeAll: false,
      },
    };
  },
  components: {
    UserInfoInput,
    TermsInfoInput,
  },
  created() {
    this.isMobile = window.innerWidth < 992;
    console.log();
    this.$EventBus.$on('ConfirmReserveNew', this.ConfirmReserveNew);
    window.addEventListener('scroll', this.handleScroll);
    this.userInfo.bookName = this.ReserveData.bookName;
    this.userInfo.bookHpNo = this.ReserveData.bookHpNo;
    this.userInfo.email = this.ReserveData.email;
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    this.$EventBus.$off('ConfirmReserveNew', this.ConfirmReserveNew);
  },
  methods: {
    async prevStage() {
      const confirm = await this.showMsgBoxConfirm('입력하신 접수내용이 초기화 됩니다', '입력초기화');
      if (confirm) {
        // this.ReserveData.bookName = this.userInfo.bookName;
        // this.ReserveData.bookHpNo = this.userInfo.bookHpNo;
        // this.ReserveData.email = this.userInfo.email;
        console.log('prevStage');
        this.$emit('prevStage');
      }
    },
    handleScroll() {
      console.log('-------->', window.scrollY);
      if (window.scrollY > 370) {
        this.isWhiteLogo = false;
        this.isScroll = true;
      } else {
        this.isBright = true;
        this.isScroll = false;
      }
      console.log(this.isBright, this.isScroll);
    },

    showErrDialog(msg) {
      this.$bvModal.msgBoxOk(msg, {
        centered: true,
        okTitle: '확인',
        okVariant: 'primary',
      });
    },

    async ConfirmReserveNew() {
      if (!this.receiptWorking) {
        try {
          let flag1 = this.userInfoCheck();
          let flag3 = this.termsAllChecked();

          // USER INFO CHECK
          if (flag1) {
            console.log('1');
          } else {
            console.log('2');
            this.showErrDialog('예약자 성명과 연락처를 확인해 주세요.');
            return;
          }

          // TERMS CHECK
          if (flag3) {
            console.log('5');
          } else {
            console.log('6');

            if (!this.termsInfo.agreeCancel) {
              this.showErrDialog('취소 규정에 동의하지 않으면 진행할 수 없습니다.');
              return;
            }

            if (!this.termsInfo.agreePersonalCollect) {
              this.showErrDialog('개인정보 수집 및 이용에 동의 하지 않으면 진행할 수 없습니다');
              return;
            }

            if (!this.termsInfo.agreePersonalGive) {
              this.showErrDialog('개인정보 처리위탁에 동의 하지 않으면 진행할 수 없습니다.');
              return;
            }
          }

          if (flag1 && flag3) {
            // 통과시 정상
            // reserveService.
            console.log(this.ReserveData);

            const data = {
              programCode: this.ReserveData.programCode,
              mOptionCode: this.ReserveData.mOptionCode,
              sOptionCode: this.ReserveData.sOptionCode,
              personCnt: this.ReserveData.personCnt,
              reqDate: this.ReserveData.reqDate,
              reqTime: this.ReserveData.reqTime,
              reqMemo: this.ReserveData.reqMemo,
              bookName: this.userInfo.bookName,
              bookHpNo: this.userInfo.bookHpNo,
              email: this.userInfo.email,
            };
            console.log(data);
            const result = await reserveService.ReservNew(data);
            if (result.resultCode !== '0000') {
              this.showMsgBoxOk(result.msg);
              return;
            }
            this.$emit('nextStage', result.obj.reservNo);
          }
        } finally {
          this.receiptWorking = false;
        }
      } else {
        this.showMsgBoxOk('이미 예약작업이 진행중입니다.');
      }
    },

    userInfoCheck() {
      let flag1 = !this.isEmpty(this.userInfo.bookName);
      let flag2 = this.isPhoneNumber(this.userInfo.bookHpNo);
      return flag1 && flag2;
    },
    isEmpty(str) {
      return !str || str.length === 0;
    },
    isPhoneNumber(str) {
      return !this.isEmpty(str) && str.length >= 13;
    },

    termsAllChecked() {
      return this.termsInfo.agreeCancel && this.termsInfo.agreePersonalCollect && this.termsInfo.agreePersonalGive;
    },
  },
};
</script>

<style scoped lang="scss">
.contentArea {
  display: flex;
  max-width: 1180px;
  margin-left: auto;
  margin-right: auto;
  .leftContent {
    width: 100%;
  }
  .rightContent {
    //width: 35%;
    .rightContent-fixed {
      top: 4rem;
      display: inherit;
      position: fixed;
      //left: 65%;
      //width: 35%;
      -webkit-transition: all 0.5s ease;
      transition: all 0.5s ease;
    }
  }
}

@media (min-width: 992px) {
  .buttonGroup {
    display: flex;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 1rem;
    width: 50%;
    .moveButton {
      display: inline-flex;
      align-items: center;
      height: 2.3rem;
      font-size: 0.8rem;
      width: 100%;
      margin: 1rem;

      background-color: #524a3d !important;
      padding: 0px !important;
      color: white;
      border: none;
      outline: none;
      span {
        padding: 0px;
        width: 100%;
        text-align: center;
        padding: 0px !important;
      }
      &:hover {
        background-color: #403a30 !important;
      }
    }
  }
}

@media (max-width: 992px) {
  .contentArea {
    display: block;
    .leftContent {
      width: 100%;
    }
    .rightContent {
      //width: 35%;
      .rightContent-fixed {
        top: 4rem;
        display: inherit;
        position: relative;
        //left: 65%;
        //width: 35%;
        -webkit-transition: all 0.5s ease;
        transition: all 0.5s ease;
      }
    }
  }
  .buttonGroup {
    display: flex;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 1rem;
    width: 100%;
    .moveButton {
      display: inline-flex;
      align-items: center;
      height: 2.3rem;
      font-size: 0.8rem;
      width: 100%;
      margin: 1rem;

      background-color: #524a3d !important;
      padding: 0px !important;
      color: white;
      border: none;
      outline: none;
      span {
        padding: 0px;
        width: 100%;
        text-align: center;
        padding: 0px !important;
      }
      &:hover {
        background-color: #403a30 !important;
      }
    }
  }
}
</style>
